import { IconButton } from '@material-ui/core';
import { styled } from '@material-ui/styles';
import { AppRoutes } from 'Configs/AppRoutes';
import { EstimationUrlParameters, UrlHelper } from 'Helpers';
import { LocationDescriptor } from 'history';
import React from 'react';
import { Link } from 'react-router-dom';
import { useVersion } from 'Types/RouteParams';
import { Assets } from 'Web/assets/Assets';

export const ButtonBack = () => {
    const version = useVersion();
    const to: LocationDescriptor<unknown> = {
        pathname: AppRoutes.MY_PROJECTS,
        search: UrlHelper.toQueryParams<EstimationUrlParameters>({ version }).toString(),
    };
    return (
        <Link to={to}>
            <Content>
                <Assets.IconArrowPrevious style={{ width: 7, height: 13 }} />
            </Content>
        </Link>
    );
};
const Content = styled(IconButton)({ width: 41, height: 41, paddingTop: 8 });
